<template>
  <b-card class="conversations-graph" :class="isDarkMode ? 'dark' : ''">
    <span class="conversations-graph--title" :class="isDarkMode ? 'dark' : ''"
      >Opt In / Opt Out / Engagement
    </span>
    <span class="conversations-graph--count" :class="isDarkMode ? 'dark' : ''"
      >{{ formatNumber(totalCount) }} Total Subscribers</span
    >
    <div id="subscribersActivityChart"></div>
  </b-card>
</template>

<script>
import ApexCharts from "apexcharts";
import formatter from "@/mixins/formatter";

let subscribersActivityChart = null;
export default {
  name: "SubscriberActivityGraph",
  data() {
    return {
      series: [],
      options: {
        chart: {
          type: "bar",
          height: "80%",
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "top",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            borderRadiusApplication: "end", // 'around', 'end'
            borderRadiusWhenStacked: "last", // 'all', 'last'
          },
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: "13px",
                fontWeight: 900,
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          position: "top",
          labels: {
            colors: "#989898",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          theme: this.isDarkMode ? "dark" : "light",
        },
      },
      totalCount: 0,
    };
  },
  mixins: [formatter],
  watch: {
    series(newValue, oldValue) {
      if (newValue !== oldValue) {
        subscribersActivityChart.updateSeries(this.series);
        subscribersActivityChart.updateOptions(this.options);
      }
    },
    SubscribersActivityData(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getFormattedData();
      }
    },
    isDarkMode(newVal, oldVal) {
      if (newVal !== oldVal) {
        subscribersActivityChart.updateOptions({
          tooltip: {
            theme: newVal === true ? "dark" : "light",
          },
        });
      }
    },
  },
  mounted() {
    this.getFormattedData();
    this.renderChart();
  },
  methods: {
    getFormattedData() {
      this.totalCount = 0;
      const optInData = [];
      const optOutData = [];
      const engagementData = [];
      const monthData = [];
      if (
        this.SubscribersActivityData &&
        this.SubscribersActivityData.length > 0
      ) {
        this.SubscribersActivityData.forEach((value) => {
          this.totalCount += value.total;
          optInData.push(value.optin);
          optOutData.push(value.optout);
          engagementData.push(value.engagement);
          monthData.push(value.x_axis);
        });
      }
      this.series = [
        {
          name: "Opt-In",
          data: [...optInData],
          // color: "#36a2eb",
        },
        {
          name: "Opt-Out",
          data: [...optOutData],
          // color: "#ff9f40",
        },
        {
          name: "Engagement",
          data: [...engagementData],
          // color: "#ff9f40",
        },
      ];
      this.options = {
        ...this.options,
        series: this.series,
        xaxis: {
          categories: [...monthData],
        },
      };
    },
    renderChart() {
      subscribersActivityChart = new ApexCharts(
        document.querySelector("#subscribersActivityChart"),
        {
          ...this.options,
          series: [...this.series],
        }
      );
      subscribersActivityChart.render();
    },
  },
  beforeDestroy() {
    if (subscribersActivityChart) {
      subscribersActivityChart.destroy();
    }
  },
  props: {
    isDarkMode: Boolean,
    SubscribersActivityData: Array,
  },
};
</script>



<style lang="scss">
.subscriber-graph {
  &.dark {
    .apexcharts-text tspan {
      fill: #b2b9bf;
    }
  }
  .apexcharts-text tspan {
    fill: #000;
  }
  &.card {
    height: 100%;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);
    border-radius: 1rem;
    margin-bottom: 0;
    padding-bottom: 10px;
  }
  &--title {
    font-size: 1.125rem;
    text-align: left;
    color: #333843;
    font-weight: 600;
    margin-bottom: 0;
    display: block;
    &.dark {
      color: #b2b9bf !important;
    }
  }

  &--count {
    text-align: left;
    font-size: 0.75rem;
    color: #667085;

    font-weight: 500;
    padding-bottom: 16px;
    &.dark {
      color: #b2b9bf !important;
    }
  }

  & #subscribersActivityChart {
    @media (min-width: 1600px) {
      height: 386px !important;
    }
  }
}
</style>